/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class BackupScopeSummary {
  'totalResources': number;
  'scopeResources': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "totalResources",
      "baseName": "totalResources",
      "type": "number",
      "format": ""
    },
    {
      "name": "scopeResources",
      "baseName": "scopeResources",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupScopeSummary.attributeTypeMap;
  }

  public constructor() {
  }
}

